import React from 'react';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
import { countries } from 'react-flag-icon-css/lib/static/enums';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputCountryCode = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Country"), colon: false }, props.form.getFieldDecorator('countryCode', {
    initialValue: props.initialValue || '',
    rules: [{
            max: 2,
            message: 'ISO 3166-1 alpha-2 country codes only',
        }, {
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Select, { size: 'large', disabled: props.isDisabled, allowClear: true, showSearch: true, optionFilterProp: 'children', filterOption: function (input, option) { return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0; } }, countries && countries.map(function (c) { return (React.createElement(Select.Option, { key: c.code, value: c.code }, c.name)); }))))); };
export default InputCountryCode;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthlete/InputCountryCode.tsx
// module id = 1203
// module chunks = 0